module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deletesalesdataModal
    }
  }, [_vm._v("Delete Data")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("Geographic Area")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "35px",
      "font-size": "20px"
    }
  }, [_vm._v(" " + _vm._s(_vm.salesdata.regionName))])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("Location")]), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "30px",
      "font-size": "20px"
    }
  }, [_vm._v(" " + _vm._s(_vm.salesdata.siteSiteName))])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportedDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "reportedDate",
      "required": "",
      "lang": "en",
      "name": "reportedDate",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.salesdata.reportedDate),
      callback: function($$v) {
        _vm.$set(_vm.salesdata, "reportedDate", $$v)
      },
      expression: "salesdata.reportedDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportedDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Sales Data")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nozzlesNumber"
    }
  }, _vm._l((_vm.total_dispancer), function(dispenser_number, i) {
    return _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "dispenser"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Dispenser " + _vm._s(dispenser_number) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAOpening),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAOpening"
      }],
      ref: "nozzleAOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAOpening)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleAOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAOpening", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAClosing),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAClosing"
      }],
      ref: "nozzleAClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAClosing)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleAClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAClosing", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump A")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleA.nozzleAMeterJump),
        expression: "salesdata.dispenserData[i].nozzleA.nozzleAMeterJump"
      }],
      ref: "nozzleAMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleA.nozzleAMeterJump)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleA, "nozzleAMeterJump", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBOpening),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBOpening"
      }],
      ref: "nozzleBOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBOpening)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleBOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBOpening", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzles B closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBClosing),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBClosing"
      }],
      ref: "nozzleBClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBClosing)
      },
      on: {
        "change": function($event) {
          return _vm.compareValue($event, i, 'nozzleBClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBClosing", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump B")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.salesdata.dispenserData[i].nozzleB.nozzleBMeterJump),
        expression: "salesdata.dispenserData[i].nozzleB.nozzleBMeterJump"
      }],
      ref: "nozzleBMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.salesdata.dispenserData[i].nozzleB.nozzleBMeterJump)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.salesdata.dispenserData[i].nozzleB, "nozzleBMeterJump", $event.target.value)
        }
      }
    })])])])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Total Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.totalValue),
      expression: "salesdata.totalValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "totalValue"
    },
    domProps: {
      "value": (_vm.salesdata.totalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesdata, "totalValue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'salesdata'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-5 btn gradientbt2",
    staticStyle: {
      "background-image": "linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255))",
      "color": "white"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updatesalesdata
    }
  }, [_vm._v("Update Sales Status")])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99538f78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Salesdata/SalesdataDetails.vue
// module id = 2379
// module chunks = 1